import { render, staticRenderFns } from "./promotionPreference.vue?vue&type=template&id=799a4bad&scoped=true"
import script from "./promotionPreference.vue?vue&type=script&lang=js"
export * from "./promotionPreference.vue?vue&type=script&lang=js"
import style0 from "./promotionPreference.vue?vue&type=style&index=0&id=799a4bad&prod&lang=css"
import style1 from "./promotionPreference.vue?vue&type=style&index=1&id=799a4bad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799a4bad",
  null
  
)

export default component.exports